import React, { FC, useMemo, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import { DropDownOptions } from 'devextreme-react/select-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { DateBox, NumberBox, SelectBox } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';

import { useGetFactoryFullNamesQuery } from 'bus/factory/services/services';
import { useCreateMaterialBalanceMutation } from 'bus/materialBalance/services';
import { MaterialBalance } from 'bus/materialBalance/types';

type CreateEditModalProps = {
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
  id: number | null;
};

const initialForm: MaterialBalance = {
  date: '',
  factoryId: null,
  materialId: null,
  quantity: undefined,
};

const CreateEditModal: FC<CreateEditModalProps> = ({ changeVisible, refresh, visible, id }) => {
  let createGroupValidationRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<MaterialBalance>(initialForm);

  const [create, { isLoading: isLoadingCreate }] = useCreateMaterialBalanceMutation();
  const { data } = useGetFactoryFullNamesQuery();

  const disabledSubmit = isLoadingCreate;

  const onShown = async () => {
    if (id) {
      //TODO дополнить когда будет редактирование
    } else {
      setForm(initialForm);
    }
  };

  const storeMaterial: any = useMemo(() => {
    return $createDataSource('/v1/Material', 'id');
  }, []);

  const onHidden = () => {
    setForm(initialForm);
    createGroupValidationRef.current?.instance.reset();
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createGroupValidationRef.current?.instance.validate().isValid) {
      if (id) {
        //TODO дополнить когда будет редактирование
      } else {
        await create({ ...form });
      }
      changeVisible(false);
      refresh();
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Начальные остатки"
        width={500}
        onShowing={onShown}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createGroupValidationRef}>
                <Form id="test-facrory" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Дата" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="date"
                            onValueChange={(e) => setForm((prev) => ({ ...prev, date: e as string }))}
                            useMaskBehavior
                            dateSerializationFormat="yyyy-MM-dd"
                            value={form.date}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Дата" />
                            </Validator>
                          </DateBox>
                        </AppFiledBox>

                        <AppFiledBox label="Площадка" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            items={data}
                            displayExpr="name"
                            valueExpr="id"
                            value={form.factoryId}
                            onItemClick={(e) => {
                              setForm((prev) => ({ ...prev, factoryId: e.itemData.id }));
                            }}
                          >
                            <DropDownOptions title="Выберите Площадку" closeOnOutsideClick={true} showTitle={false} />
                            <Validator>
                              <RequiredRule message="Выберите Площадку" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>

                        <AppFiledBox label="Материал" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={storeMaterial}
                            displayExpr="name"
                            valueExpr="id"
                            value={form.materialId}
                            onItemClick={(e) => {
                              setForm((prev) => ({ ...prev, materialId: e.itemData.id }));
                            }}
                          >
                            <DropDownOptions title="Выберите Материал" closeOnOutsideClick={true} showTitle={false} />
                            <Validator>
                              <RequiredRule message="Выберите Материал" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>

                        <AppFiledBox label="Объем" labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="0"
                            value={form.quantity}
                            onValueChanged={(e) => {
                              setForm((prev) => ({ ...prev, quantity: e.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Объем" />
                            </Validator>
                          </NumberBox>
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={disabledSubmit}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default CreateEditModal;
